<div class="seat-item">
  <div class="seat-icon">
    <span class="seat-icon-label">{{ seat.isTable ? 'Mesa' : 'Fila' }}</span>
    <span class="seat-icon-letter">{{ seat.row }}</span>
  </div>
  <div class="seat-info">
    <div class="seat-name">
      {{ seat.previewText }}
    </div>
    <div class="seat-number">RD${{ seat.price.toLocaleString() }}</div>
  </div>
</div>
